<!-- eslint-disable -->
<template lang="pug">
    .result__buttons
        .result__button(v-if="$slots['mainButton']")
            slot(name="mainButton")
        template(v-if="isResultButtonsShown")
            .result__button
                cs-button(
                    @click="$router.push({name: 'dashboard'})"
                    color="blue"
                    pattern="primary-outline"
                )
                    | {{ $i18n.t('common.common_navigation_goToMain') }}
            .result__button(v-if="$slots['default']")
                slot
            template(v-if="!exerciseId")
                .result__button(v-if="isShowRestartButton && !isNavigatorInFastReading")
                    cs-button(
                        color="blue"
                        pattern="primary-outline"
                        @click="$emit('restartGame')"
                    )
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_restart') }}
                .result__button
                    cs-button(
                        @click="navigateToGameSource"
                        color="blue"
                        pattern="primary-outline"
                    )
                        | {{ gameSourceNavigationLabel }}
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex';

    export default {
        props: {
            exerciseId: {
                type: [ Number, String ],
                default: 0
            },
            gamesType: {
                type: String,
                default: 'mentalArithmetic'
            },
            gameName: {
                type: String,
                default: '',
            },
            showResultButtons: {
                type: Boolean,
                default: false
            },
            showRestartButton: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState({
                lessonConductingTemplate: state => state.trainer.lessonConductingTemplate,
                user: state => state.auth.user,
            }),
            isResultButtonsShown () {
                return !this.$slots['mainButton'] || this.showResultButtons;
            },
            gameSourceNavigationLabel() {
                return this.lessonConductingTemplate
                    ? this.$i18n.t('common.common_navigation_goToTemplate')
                    : this.$i18n.t('common.common_navigation_goToTrainer');
            },
            isShowRestartButton () {
                if (['CorrectiveSamples', 'MentalDrawing', 'HandsUp', 'RepeatAfterMe', 'Chameleon', 'Scout'].includes(this.gameName)) {
                    return this.showRestartButton;
                }
                if (this.gamesType === 'mentalArithmetic') {
                    return !!this.lessonConductingTemplate;
                }
                return this.showRestartButton;
            },
            isNavigatorInFastReading () {
                return this.gamesType === 'fastReading' && this.gameName === 'Navigator'
            },
        },
        methods: {
            navigateToGameSource() {
                return this.lessonConductingTemplate
                    ? this.$router.push({name: 'lesson-conducting-template:list'})
                    : this.$router.push({name: 'trainer:games', params: {gamesType: this.gamesType}});
            }
        }
    }
</script>

<style lang="scss" scoped>
    .result__buttons {
        display: flex;
        flex-direction: column;
        margin: -10px;
        @include media($lg) {
            flex-wrap: wrap;
            flex-direction: row;
            justify-content: center;
        }
    }

    .result__button {
        padding: 10px;
    }
</style>
